import React from "react";
import { PaginationTable, PaginationDataProps } from "../../../views/components/common/PagginationTable";
import { OrderIndListData } from "../../../data/trading/orderIndicative/types";
import { useOrderIDColumns } from "./useOrderIndColumns";
import { AccessRights } from "../../../core/navigation/types";
import { useOrderIndActions, useDeleteOrderIndAction } from "./useOrderIndActions";

export interface OrderIndTableProps {
	userAccessRights: AccessRights;
	getData: () => void;
}

type OrderIndTablePropsType =
	OrderIndTableProps &
	PaginationDataProps<OrderIndListData>;

export const OrderIndTable: React.FunctionComponent<OrderIndTablePropsType> = ({
	userAccessRights,
	getData,
	...tableProps
}) => {
	const columns = useOrderIDColumns();
	const actions = useOrderIndActions(userAccessRights);
	const onDeleteOrderInd = useDeleteOrderIndAction();

	return (
		<PaginationTable<OrderIndListData>
			{...tableProps}
			getData={getData}
			title=""
			columns={columns}
			actions={actions}
			options={{
				toolbar: false,
				pageSize: tableProps.pageIndex.itemsPerPage,
				actionsColumnIndex: -1,
			}}
			editable={
				userAccessRights !== AccessRights.ReadOnly
					? {
						onRowDelete: onDeleteOrderInd,
					}
					: {}
			}
		/>
	);
};

export default OrderIndTable;